export default "__VITE_ASSET__BdMkAUr5__"